import React, {FC, useCallback, useEffect, useState} from 'react';
import {useParams, useLocation, generatePath, Link} from 'react-router-dom';
import reducer from '../reducer';
import saga from '../saga';
import { useDispatch, useSelector } from 'react-redux';

import ReactPaginate from 'react-paginate';
import PaginateWrapper from '../../../components/Pagination';

// Import Styles
import styled from 'styled-components';
import Container from '../../../components/Layout/Container';
import Row from '../../../components/Layout/Row';
import Col4 from '../../../components/Layout/Grid/Col4';
import Col8 from '../../../components/Layout/Grid/Col8';
import H3 from '../../../components/Headings/H3';
import P from '../../../components/Paragraph';
import CustomHelmet from '../../../components/Helmet';
import ScrollToTop from '../../ScrollToTop';
import ApproveHrModal from '../../Tasks/Modal/approveHrModal';
import {LoadOverlaySticky} from '../../../components/Animations';
import Button from '../../../components/ButtonsStyle/index';

// Import Messages & Date
import { FormattedMessage } from 'react-intl';
import generalMessages from '../../generalMessages';
import messages from './messages';
import { formatDateObj } from '../../../utils/date';

// Import Models and other configuration
import {NewsItem} from '../../../models/newsItem';
import { ParamTypes } from '../../../models/urlParams';

// Import Actions
import { getSingleNews, getMostReadNewsByCategory } from '../actions';

// Import Selectors
import {
  makeSelectNewsItem,
  makeSelectLoading,
  makeSelectNewsItemError,
  makeSelectMostReadNewsByCategory,
  makeSelectCurrentMostReadNewsPage,
  makeSelectPageMostReadNewsCount,
} from '../selectors';

import { makeSelectisAuthenticated, makeSelectUserInfo } from '../../App/selectors';

// Can I - view
import Can from '../../../config/acl/can';
import {viewSections} from '../../../config/acl/aclReadSections';

// Share News
import ShareNews from '../ShareNews';
import { STATUSES, BASE_URL, REDUX_SAGA_KEYS, CDN_URL } from '../../../config/config';
import NewsError from './newsError';
import { truncateMetaDescription, useInjectSagaAndReducer } from '../../../utils/helpers';
import { Links } from '../../../components/LinksStyle';
import routes from '../../../config/routes';
import ButtonOptionsInline from '../../../components/PageComponents/ButtonOptionsInline';
import Title from '../../../components/PageSections/News/Title';
import Separator from '../../../components/PageSections/Separator';
import MainWrapper from '../../../components/PageSections/MainWrapper';
import Details from '../../../components/PageSections/News/Details';
import InlineButtons from '../../../components/PageSections/InlineButtons';
import MostReadNews from '../../../components/PageSections/News/MostRead';
import NoResultsStyleSm from '../../../components/NoResults/NoResultsStyle';
import colors from '../../../config/colors';

const NewsDetails: FC = () => {

  useInjectSagaAndReducer(REDUX_SAGA_KEYS.news, reducer, saga);

  const {id, assignedTo, taskId, taskType} = useParams<ParamTypes>();

  const apiUrl : string | undefined = BASE_URL;
  console.log(apiUrl, "api");
  console.log(apiUrl?.substring(0, apiUrl?.length - 4), 'sub');
  const dispatch = useDispatch();
  const location = useLocation();
  const loading = useSelector(makeSelectLoading);

  const news : NewsItem = useSelector(makeSelectNewsItem);

  const isAuth = useSelector(makeSelectisAuthenticated);
  const userInfo = useSelector(makeSelectUserInfo);
  const newsError = useSelector(makeSelectNewsItemError);
  const mostReadNewsByCategory = useSelector(makeSelectMostReadNewsByCategory);
  const pageCount = useSelector(makeSelectPageMostReadNewsCount);
  const currentPage = useSelector(makeSelectCurrentMostReadNewsPage);

  const [hrModal, setHrModal] = useState(false);
  const [shareButtonsOpen, setShareButtonsOpen] = useState(false);
  const [shareButtonsOpenBottom, setShareButtonsOpenBottom] = useState(false);

  useEffect(() => {
    dispatch(getSingleNews(id))
  }, [dispatch, id]);

  const aproveNews = () => {
    setHrModal(true);
  }

  useEffect(() => {
     let page = 1;
     if(news && news.category) {
       dispatch(getMostReadNewsByCategory(news.category, news.unique_id, page))
     }
  }, [dispatch, news]);

  const handlePageClick = useCallback((data: any) => {
    let page = data.selected >= 0 ? data.selected + 1 : 0;
    
    dispatch(getMostReadNewsByCategory(news.category, news.unique_id, page));
  }, [dispatch, news]);

  const openShare = useCallback(() => {
    setShareButtonsOpen(!shareButtonsOpen);
  }, [shareButtonsOpen]);

  const openShareBottom = useCallback(() => {
    setShareButtonsOpenBottom(!shareButtonsOpenBottom);
  }, [shareButtonsOpenBottom]);

  const customMetaTitle = (id: string) => {
      if(id ==='60dc43688750a') {
        return 'Kako ne treba da izgleda oglas za posao';
      }
      if(id ==='60dc398910412') {
        return 'Vodič za pronalaženje posla za nove diplomce';
      }
      if(id ==='60dc6b8330370') {
        return 'Ko su frilenseri i kako uspeti u frilensingu?';
      }
      if(id ==='60f55392d73f7') {
        return 'Pozitivne navike koje povećavaju šanse za pronalaženje posla';
      }
      if(id ==='60f5519494c6b') {
        return 'Najvažnije digitalne veštine koje treba uključiti u CV';
      }
      if(id ==='60f550428303e') {
        return ' Kako pristupiti IT kandidatima';
      }

     return null;
  }

  const customMetaDesc = (id: string) => {
    if(id ==='60dc43688750a') {
      return 'Kako razlikovati dobre i loše primere oglasa za posao? Saznaj kako ne treba da izgleda oglas za posao i zašto ga možda treba preskočiti. Prati Loop blog!';
    }
    if(id ==='60dc398910412') {
      return 'Upravo si završio/la fakultet i u potrazi si za poslom? Loop vodič i saveti za pronalaženje posla za nove diplomce će ti pomoći. Saznaj više! ';
    }
    if(id ==='60dc6b8330370') {
      return 'Kako izgleda uspešna priča jednog frilensera u Srbiji? Filip Rastović je za loop ispričao o svom razvojnom putu u frilensingu. Pročitaj više o ovoj temi! ';
    }
    if(id ==='60f55392d73f7') {
      return 'U potrazi si za poslom? Ove pozitivne navike mogu ti pomoći da lakše nađeš željeno zaposlenje. Saznaj više na loopu.';
    }
    if(id ==='60f5519494c6b') {
      return ' Koje su to najvažnije digitalne veštine i znanja? Saznajte kako pravilno opisati svoju digitalnu kompetenciju u CV-ju. Pročitajte više na loopu.';
    }
    if(id ==='60f550428303e') {
      return ' Kako privući IT stručnjake i zadržati ih? Proces regrutovanja programera iziskuje posebnu strategiju. Saznaj više na loopu.';
    }
    return null;
 }

  return (
      <NewsDetailsWrapper>
        {loading ?
        <LoadOverlaySticky />
        :
        <>
        <ScrollToTop />
        {newsError ? <NewsError /> : news ?
         <>
        <CustomHelmet
          title={news.seo_title ? news.seo_title : `${customMetaTitle(id) ? customMetaTitle(id) : news.title ? news.title : ''}`}
          description={news.seo_description ? truncateMetaDescription(news.seo_description) : `${customMetaDesc(id) ? customMetaDesc(id) : truncateMetaDescription(news.body) ? truncateMetaDescription(news.body) : ''}`}
          ogTitle={news.seo_title ? news.seo_title : `${customMetaTitle(id) ? customMetaTitle(id) : news.title ? news.title : ''}`}
          ogDescription={news.seo_description ? truncateMetaDescription(news.seo_description) : `${customMetaDesc(id) ? customMetaDesc(id) :  truncateMetaDescription(news.body) ? truncateMetaDescription(news.body) : ''}`}
          pageUrl={location? location.pathname : ''}
          ogImage={news.seo_image_file_name && CDN_URL ? CDN_URL + news.seo_image_file_name : apiUrl ? apiUrl.substring(0, apiUrl.length - 4) + '/images/news_og.png' : ''}
          keywords={news.keywords ? news.keywords : ''}
          ogImageAlt={news.seo_image_alt ? news.seo_image_alt : ''}
          jsonLd={`
            {
              "@context": "http://schema.org/",
              "@id": "ImageObject",
              "@type": "ImageObject",
               "url": "${news.seo_image_file_name && CDN_URL ? CDN_URL + news.seo_image_file_name : apiUrl ? apiUrl.substring(0, apiUrl.length - 4) + '/images/news_og.png' : ''}"
            }
          `}
        />
        <Separator />
        <Container>
          <MainWrapper>
            <Title item={news} />
            {news.status !== STATUSES.process ?
              <InlineButtons>
                <Button theme="white" onClick={openShare}>
                  <svg><use xlinkHref={`#share`} /></svg>
                  <FormattedMessage {...messages.ShareNews} />
                </Button>
              </InlineButtons>
            : null}
            {shareButtonsOpen ?
              <ShareNews news={news} />
            : null}
            <Row>
              <Col8News>
                <Details item={news} />
                {news.status !== STATUSES.process ?
                  <NewsPublished><strong><FormattedMessage {...messages.NewsPublished} />: {formatDateObj(news.published_at)} </strong></NewsPublished>
                : userInfo.unique_id === assignedTo ? null :
                  <H3><FormattedMessage {...generalMessages.ProcessStatus}/></H3> }
                {userInfo.unique_id === assignedTo ?
                  <Can I="view" a={viewSections.section.jobs.hrButton}>
                    <ButtonOptionsInline>
                      <Links theme='purple' to={generatePath(routes.NewsEdit, {'urlSlug': news.slug, 'assignedTo': assignedTo, 'id': news.unique_id,'taskId': taskId, 'taskType': taskType })}><FormattedMessage {...generalMessages.Edit} /></Links>
                      {!news.approved ? <Button onClick={aproveNews}><FormattedMessage {...generalMessages.Approve} /></Button> : null}
                    </ButtonOptionsInline>
                  </Can> :
                null}
              </Col8News>
              <Col4News>
                <MostReadNewsWrapper>
                  <H3>Najčitanije vesti</H3>
                  <Link to={routes.NewsPage + '?category=' + news.category}>Pogledaj sve</Link>
                  {pageCount > 1 &&
                    <PaginateWrapper>
                      <ReactPaginate
                        previousLabel={<svg><use xlinkHref={`#arrow`} /></svg>}
                        nextLabel={<svg><use xlinkHref={`#arrow`} /></svg>}
                        previousLinkClassName={"arrow-link"}
                        nextLinkClassName={"arrow-link"}
                        pageCount={pageCount}
                        forcePage={currentPage - 1}
                        marginPagesDisplayed={0}
                        pageRangeDisplayed={0}
                        onPageChange={handlePageClick}
                        containerClassName={'pagination arrows'}
                        disabledClassName={"disabled"}
                        activeClassName={'active'}
                      />
                    </PaginateWrapper>
                }
                  {mostReadNewsByCategory && mostReadNewsByCategory.length > 0 ?
                    mostReadNewsByCategory.map((item: any, i: number) => {
                      return (
                        <MostReadNews item={item}  />
                      )
                  })
                  : <NoResultsStyleSm key={'no-similar-button-wrapper'}><P><FormattedMessage {...messages.NoSimilarNews} /></P></NoResultsStyleSm>
                  }
                </MostReadNewsWrapper>
              </Col4News>
            </Row>
            {news.status !== STATUSES.process ?
                <InlineButtons>
                  <Button theme="white" onClick={openShareBottom}>
                    <svg><use xlinkHref={`#share`} /></svg>
                    <FormattedMessage {...messages.ShareNews} />
                  </Button>
                </InlineButtons>
              : null}
              {shareButtonsOpenBottom ?
                <ShareNews news={news} />
              : null}
          </MainWrapper>
        </Container>
        </> : null
        }
        </>
      }
      {news ?
        <ApproveHrModal
          closeModal={setHrModal}
          unique_id={news.unique_id}
          isOpen={isAuth && hrModal}
          model='news'
          taskId={taskId}
        /> : null
      }
      </NewsDetailsWrapper>

  )
}

const NewsDetailsWrapper = styled.div``;

const MostReadNewsWrapper = styled.div`
  position: relative;
  background: ${colors.GRAY_EXTRA_LIGHT};
  padding: 20px;
  a {
    font-family: "Gilroy-Medium";
  }
`;

const Col8News = styled(Col8)`
  @media (max-width: 1025px) {
    flex: 0 0 100%;
    max-width: 100%;
  }
`;

const Col4News = styled(Col4)`
  @media (max-width: 1025px) {
    flex: 0 0 100%;
    max-width: 100%;
  }
`;

const NewsPublished = styled(P)`
  font-size: 14px;
  margin-bottom: 10px;
`;

export default NewsDetails;
